import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { OrganizationDetailForm } from "@/features/organization/OrganizationDetailForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function OrganizationDetail() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/organization",
            label: "Organization",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>Organization Detail</H2>
      <OrganizationDetailForm id={id} />
    </>
  );
}
